import { RESULT_STATUSES, ResultStatus } from '../models/test-run.model';
import type { ResPillStatus } from '../components/res-pill/res-pill.component';
import { TEST_RUN_TO_RES_PILL } from './test-run-outcome';

/**
 * Icons der Ergebnis-Knoepfe im Runner und des Statuspunkts in der Schrittliste. Nicht zu
 * verwechseln mit `TEST_RUN_STATUS_ICON`: die Abschluss-Karte zeigt bewusst andere Symbole.
 */
export const RESULT_STATUS_ICON: Record<ResultStatus, string> = {
  NOT_RUN: 'radio_button_unchecked',
  RUNNING: 'sync',
  PASSED: 'check',
  FAILED: 'close',
  BLOCKED: 'shield',
  SKIPPED: 'chevron_right',
};

const RES_PILL_ICON = Object.fromEntries(
  RESULT_STATUSES.map((status) => [TEST_RUN_TO_RES_PILL[status], RESULT_STATUS_ICON[status]]),
) as Record<ResPillStatus, string>;

export function resPillIcon(status: ResPillStatus): string {
  return RES_PILL_ICON[status];
}
